import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "キャンセル" },
  { value: 2, text: "却下" },
  { value: 3, text: "交換品なし" },
]);
